import Contact from "./Contact";
import Project from "./Project";
import Skill from "./Skill";
import Footer from "./Footer";
import About from "./About";

// bg-violet-200 text-neutral-800
// bg-slate-800 text-violet-200
const Main = () => {
  return (
    <div id="main" className="px-40 bg-slate-800 text-violet-200">
      <About />
      <Project />
      <Skill />
      <Contact/>
      <Footer />
    </div>
  );
};

export default Main;
